export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const CLEAR_CATEGORY = 'CLEAR_CATEGORY';
export const CLEAR_PRODUCT = 'CLEAR_PRODUCT';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const GET_PRODUCT_BY_ID = 'GET_PRODUCT_BY_ID';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const CLEAR_CATEGORY_REPLY = 'CLEAR_CATEGORY_REPLY';
export const READ_CATEGORY = 'READ_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const CREATE_USER = "CREATE_USER"
export const READ_USER= 'READ_USER';
export const UPDATE_USER= 'UPDATE_USER';
export const DELETE_USER='DELETE_USER';
export const LOGIN= 'LOGIN';
export const LOGOUT= 'LOGOUT';
export const ADMIN_ALLOWED= 'ADMIN_ALLOWED';
export const FILTER_BY_CATEGORY = 'FILTER_BY_CATEGORY';
export const FILTER_BY_PRICE = 'FILTER_BY_PRICE';
export const FILTER_BY_NAME = 'FILTER_BY_NAME';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';
export const GET_PRODUCT_REVIEWS = 'GET_PRODUCT_REVIEWS';
export const GET_COINS = 'GET_COINS';
export const ADD_PRODUCT_WISHLIST = 'ADD_PRODUCT_WISHLIST';
export const GET_WISHLIST = 'GET_WISHLIST';
export const GET_WISHLIST_ID = 'GET_WISHLIST_ID';
export const DELETE_WISHLIST = "DELETE_WISHLIST";
export const GET_COUPONS = "GET_COUPONS"
export const SET_DESC = "SET_DESC"